




























































































































































































import { Component } from 'vue-property-decorator';
import '@/assets/scss/pages/page-auth.scss';
import { BaseMixin } from '@/mixins/BaseMixin';
import { mixins } from 'vue-class-component';
import {
  AntragsbuchFilter,
  AntragsbuchFilterDto,
  DateFilter,
  IAgency,
  IUser,
  PolicyFilterDto,
  PolicyStatus,
} from 'admiral-core';
import UserStatusBadge from '@/components/common/UserStatusBadge.vue';

import {
  CheckIcon,
  Edit2Icon,
  FileTextIcon,
  InfoIcon,
  MoreVerticalIcon,
  ArrowUpRightIcon,
} from 'vue-feather-icons';
import Avatar from '@/components/common/Avatar.vue';
import AButton from '@/components/common/AButton.vue';
import { AgencyApi } from '@/services/AgencyApi';
import AdmiralCheckbox from '@/components/common/selects/AdmiralCheckbox.vue';
import { PermissionMixin } from '@/mixins/PermissionMixin';
import { PolicyApi } from '@/services/PolicyApi';
import { FileApi } from '@/services/FileApi';
import { AuthAction } from '@/store/AuthModule';

@Component({
  name: 'agency-info-settings',
  components: {
    AdmiralCheckbox,
    Avatar,
    UserStatusBadge,
    MoreVerticalIcon,
    Edit2Icon,
    CheckIcon,
    AButton,
    InfoIcon,
    FileTextIcon,
    ArrowUpRightIcon,
  },
})
class AgencyInfoSettings extends mixins(BaseMixin, PermissionMixin) {
  isLoading = false;
  isDone = false;
  error = '';
  success = '';
  model: Partial<IAgency> = {
    name: '',
  };
  storageUsed = 0;

  isTransferPoliciesLoading = false;
  openPoliciesCount: number | null = null;
  lastBusinessYear: number | null = null;
  currentBusinessYear: number | null = null;
  observer: IntersectionObserver | null = null;

  async mounted() {
    await this.getAgencyStorageUsage();
    this.model = {
      ...this.agency,
    };
    this.lastBusinessYear = new Date().getFullYear() - 1;
    this.currentBusinessYear = new Date().getFullYear();
    this.observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        this.loadOpenPoliciesCount();
        this.observer?.disconnect();
      }
    });

    this.observer.observe(this.$el);
  }

  beforeDestroy() {
    this.observer?.disconnect();
  }

  get hasKbv() {
    return this.users.some((u: IUser) => u.type === 'kbv');
  }

  async handleSubmit(evt: Event) {
    evt.preventDefault();
    this.success = '';
    this.error = '';

    if (this.model.name && this.model.name?.length <= 3) {
      this.error = 'Ungültiger Agenturname';
      return;
    }

    try {
      this.isLoading = true;

      await AgencyApi.updateSettings(this.agency.id, {
        agency: this.agency,
        name: this.model.name!,

        moduleBusinessPlan: this.model.moduleBusinessPlan!,
        moduleCompetitionsHessClub: this.model.moduleCompetitionsHessClub!,
        moduleCompetitionsRing: this.model.moduleCompetitionsRing!,
        moduleKbvBusinessPlanPlus: this.model.moduleKbvBusinessPlanPlus!,
        moduleKbvWinnersClub: this.model.moduleKbvWinnersClub!,
        moduleFallAds: this.model.moduleFallAds!,
        moduleKbvFallAds: this.model.moduleKbvFallAds!,

        moduleAntragsbuch: this.model.moduleAntragsbuch!,
        moduleStatistics: this.model.moduleStatistics!,
        wording: this.model.wording!,
      });

      await this.$store.dispatch('DataModule/fetchAgency');
      this.isLoading = false;
      this.success = 'Erfolgreich gespeichert.';
    } catch (e) {
      this.isLoading = false;
      this.$toastr.e(
        'Beim Speichern ist etwas schiefgegangen. Wir haben den Fehler erfasst und kümmern uns schnellstmöglich.',
      );
      throw e;
    }
  }

  async handleExportAntragsbuch() {
    try {
      const filter: AntragsbuchFilterDto = {
        agency: this.agency,
        status: [PolicyStatus.POLICED],
      };

      const response = await PolicyApi.exportAntragsbuch(filter);
      const date = new Date().toISOString().split('T')[0];

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `Antragsbuch_${date}.csv`);

      document.body.appendChild(link);
      link.click();
    } catch (e) {
      this.$toastr.e(
        'Beim Exportieren der Anbahnungen ist etwas schiefgegangen. Wir haben den Fehler erfasst und kümmern uns schnellstmöglich.',
      );
      this.$Progress.finish();
      throw e;
    }
    this.$Progress.finish();
  }

  async handleExportPolicies() {
    try {
      const filter: PolicyFilterDto = {
        agency: this.agency,
        status: [],
        showDemo: this.$store.getters['PreferencesModule/getShowDemo'],
      };

      const response = await PolicyApi.exportPolicies(filter);
      const date = new Date().toISOString().split('T')[0];

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `Anbahnungen_${date}.csv`);

      document.body.appendChild(link);
      link.click();
    } catch (e) {
      this.$toastr.e(
        'Beim Exportieren der Anbahnungen ist etwas schiefgegangen. Wir haben den Fehler erfasst und kümmern uns schnellstmöglich.',
      );
      this.$Progress.finish();
      throw e;
    }
    this.$Progress.finish();
  }

  async handleTransferPolicies() {
    try {
      this.isTransferPoliciesLoading = true;
      const response = await PolicyApi.transferOpenPolicies(this.agency);
      this.$toastr.s('Die Anbahnungen wurden erfolgreich übertragen.');
      await this.loadOpenPoliciesCount();
      const currentYear = new Date().getFullYear();
      await this.$store.dispatch(`AuthModule/${AuthAction.UpdateAchievements}`, {
        item: 'transferPolicies' + currentYear,
      });
    } catch (e) {
      this.$toastr.e(
        'Beim Übertragen der Anbahnungen ist etwas schiefgegangen. Wir haben den Fehler erfasst und kümmern uns schnellstmöglich.',
      );
    } finally {
      this.isTransferPoliciesLoading = false;
    }
  }

  async getAgencyStorageUsage() {
    try {
      const response = await FileApi.getAgencyStorageUsage();
      this.storageUsed = response.data.used;
    } catch (e) {
      console.log(e);
      // this.$toastr.e(
      //   'Beim Abrufen des Speicherplatzes ist etwas schiefgegangen. Wir haben den Fehler erfasst und kümmern uns schnellstmöglich.',
      // );
      // throw e;
    }
  }

  async loadOpenPoliciesCount() {
    try {
      const response = await PolicyApi.getPolicies({
        agency: this.agency!,
        businessYear: new Date().getFullYear() - 1,
        status: [PolicyStatus.OPEN],
        dateFilter: DateFilter.ALL,
        products: [],
        showDemo: this.$store.getters['PreferencesModule/getShowDemo'],
      });
      this.openPoliciesCount = response.data.length;
    } catch (e) {
      this.openPoliciesCount = 0;
    }
  }

  get formattedFileSize() {
    return (this.storageUsed / 1024 / 1024).toFixed(2) + ' MB';
  }
}

export default AgencyInfoSettings;
